"use client"

import Link from "next/link"
import { useImageLoadFailure } from "@/components/ui/use-image-load-failure"

/** Recall membership and counts come from CPSC; a missing logo never hides a brand. */
export function RecallBrandCard({ brand, slug, count, logo }: {
  brand: string
  slug: string
  count: number
  logo: string | null
}) {
  const { ref, failed } = useImageLoadFailure(logo)

  return (
    <Link
      href={`/recalls/${slug}`}
      className="group flex h-full min-w-0 flex-col rounded-xl border border-gray-200 bg-white p-3 transition-shadow hover:border-[#ff9951] hover:shadow-md focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#0469f0] sm:p-5"
    >
      <div className="mb-4 flex h-14 items-center justify-start" aria-hidden="true">
        {logo && !failed ? (
          // Same-origin logo from the existing brand registry; no guessed brand asset.
          // eslint-disable-next-line @next/next/no-img-element
          <img ref={ref} src={logo} alt="" width={112} height={56} loading="lazy" decoding="async" className="max-h-14 w-auto max-w-full object-contain" />
        ) : (
          <span className="flex h-12 min-w-12 items-center justify-center rounded-lg bg-blue-50 px-3 text-lg font-bold text-[#174a8b]">
            {brand.split(/[\s.-]+/).filter(Boolean).slice(0, 2).map(word => word[0]).join("")}
          </span>
        )}
      </div>
      <h3 className="mb-1 break-words text-sm font-semibold text-gray-900 sm:text-base">{brand}</h3>
      <p className="text-sm leading-relaxed text-gray-600">
        {count.toLocaleString("en-US")} {count === 1 ? "recall" : "recalls"} on record
      </p>
      <span className="mt-3 text-sm font-semibold text-[#174a8b] group-hover:underline">View recalls <span aria-hidden="true">→</span></span>
    </Link>
  )
}
